import { Container, Typography } from '@mui/material'
import { typography } from '@mui/system';
import React from 'react'
import useStyles from '../styles';


const Exhibitions = () => {
    const classes = useStyles();

    return (
        <Container className={classes.shows_container}>
            <Typography color="secondary" variant='h4'>Exhibitions</Typography>
            <Typography sx={{color: '#eeeeee'}} className={classes.about_me}>
                
                <ul>
                    <li>Art Gallery of Greater Victoria, Rentals & Sales, Victoria BC (2017-present)</li>
                    <li>Moss Street Paint In, Victoria BC, 2017</li>
                    <li>Bezanson Fine Art, Group Exhibition, Vancouver BC (2016)</li>
                    <li>Hotel Grand Pacific, Solo Exhibition, Victoria BC (2015)</li>
                    <li>Sooke Fine Art Show, Jury Selection, Sooke BC (2004, 2008, 2010, 2014, 2015, 2017)</li>
                    <li>Sidney Fine Arts Show, Jury Selection, Sidney BC (2006, 2015)</li>
                    <li>Cedar Hill Art Center Group Exibition, Victoria BC ( 2015)</li>
                    <li>Trevisan "Illusionary Realities", Invitation to Appear, Bologna, Italy (2014)</li>
                    <li>Eye Appeal Art Show and Fund Raiser, Victoria BC (2014)</li>
                    <li>Community Arts Council of Greater Victoria, Group Exhibition, Victoria BC (2013)</li>
                    <li>Florence Biennale International Art Exhibition, Committee Selection, Italy (2010)</li>
                    <li>Arad Biennale International Art Exhibition, Committee Selection, Romania (2009)</li>
                    <li>Webster Galleries Inc., Calgary, AB (2004-2008)</li>
                    <li>Butchart Gardens, Victoria, BC (2004)</li>
                    <li>Moore Fine Art Gallery, Victoria BC</li>
                    <li>Lighthouse Gallery, Victoria, BC (2004)</li>
                    <li>Community Arts Council of Greater Victoria, Solo Exhibition, Victoria BC (2004)</li>
                    <li>Sooke Harbour House, Sooke, BC</li>
                    <li>Victoria Estate Winery, Victoria, BC</li>
                    <li>Genesis Centre, Solo Exhibition, Victoria , BC (2003)</li>
                    
                </ul>
            </Typography>

        </Container>
    )
}

export default Exhibitions
